/**
 * สถานะคำสั่งซื้อ (ตรงกับ backend)
 * ใช้เป็นแหล่งเดียวสำหรับแปลเป็นภาษาไทย จะได้ไม่โชว์ค่าดิบเช่น pending_verification
 */
export const ORDER_STATUS_LABELS = {
  pending_payment: 'รอชำระเงิน',
  pending_verification: 'รอตรวจสอบ',
  paid: 'ชำระเงินแล้ว',
  processing: 'กำลังจัดเตรียม',
  shipped: 'จัดส่งแล้ว',
  delivered: 'ส่งถึงแล้ว',
  cancelled: 'ยกเลิก'
};

/**
 * แปลงรหัสสถานะเป็นข้อความภาษาไทย
 * @param {string} status - รหัสสถานะจาก API
 * @returns {string} ข้อความภาษาไทย หรือค่าตามที่ส่งมาถ้าไม่มีในรายการ
 */
export function getOrderStatusLabel(status) {
  if (!status) return '';
  return ORDER_STATUS_LABELS[status] ?? status;
}
